(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-vid-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.video-player-custom');
    videos.forEach(function (video) {
      const playPauseBtn = video.closest('.media-item-custom').querySelector('.play-pause-btn-custom');
      const playIcon = playPauseBtn.querySelector('.play-icon-custom');
      const pauseIcon = playPauseBtn.querySelector('.pause-icon-custom');
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'inline-block';
      playPauseBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'inline-block';
        } else {
          video.pause();
          playIcon.style.display = 'inline-block';
          pauseIcon.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider-product"]) return;
  try {
    
// Fade-in au chargement des images
document.querySelectorAll('.unique-portrait-slide img').forEach(img => {
  const show = () => {
    img.classList.add('loaded');
    img.offsetHeight; 
  };

  if (img.complete) {
    show();
  } else {
    img.addEventListener('load', show);
    img.addEventListener('error', show);
  }
});


// Gestion du slider infini
document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.unique-portrait-slider');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('.unique-portrait-slide'));
  const originalCount = parseInt(slider.dataset.originalCount) || 1;
  
  let isAdjusting = false;
  let scrollTimeout;

  // Fonction pour initialiser la position (au milieu = série originale)
  function initPosition() {
    const firstOriginalIndex = originalCount; // Deuxième série = originales
    const targetSlide = slides[firstOriginalIndex];
    
    if (targetSlide) {
      // Centrer sur mobile, aligner à gauche sur desktop
      if (window.innerWidth <= 768) {
        slider.scrollLeft = targetSlide.offsetLeft - (slider.offsetWidth / 2) + (targetSlide.offsetWidth / 2);
      } else {
        slider.scrollLeft = targetSlide.offsetLeft - 50;
      }
    }
  }

  // Attendre le chargement des images
  const images = slider.querySelectorAll('img');
  let loadedCount = 0;

  images.forEach(img => {
    if (img.complete) {
      loadedCount++;
    } else {
      img.addEventListener('load', () => {
        loadedCount++;
        if (loadedCount === images.length) {
          setTimeout(initPosition, 100);
        }
      });
    }
  });

  if (loadedCount === images.length) {
    setTimeout(initPosition, 100);
  }

  // Fonction pour mettre à jour l'opacité (mobile uniquement)
  function updateSlidesOpacity() {
    if (window.innerWidth > 768) return; // Pas d'effet sur desktop

    const sliderCenter = slider.scrollLeft + slider.offsetWidth / 2;
    
    slides.forEach(slide => {
      const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      const distance = Math.abs(sliderCenter - slideCenter);
      
      if (distance < slide.offsetWidth * 0.6) {
        slide.classList.add('active');
        slide.classList.remove('faded');
      } else {
        slide.classList.remove('active');
        slide.classList.add('faded');
      }
    });
  }

  // Fonction pour gérer le scroll infini
  function handleInfiniteLoop() {
    if (isAdjusting || slides.length === 0) return;

    const scrollLeft = slider.scrollLeft;
    const scrollWidth = slider.scrollWidth;
    const clientWidth = slider.offsetWidth;
    
    // Calcul des zones (chaque série = 1/3 du total)
    const sectionWidth = scrollWidth / 3;
    
    // Si on est dans la première série (clones du début)
    if (scrollLeft < sectionWidth * 0.3) {
      isAdjusting = true;
      const offset = scrollLeft;
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = sectionWidth + offset; // Sauter à la série du milieu
      
      setTimeout(() => {
        slider.style.scrollBehavior = 'smooth';
        isAdjusting = false;
      }, 50);
    }
    
    // Si on est dans la troisième série (clones de fin)
    else if (scrollLeft > sectionWidth * 2 - clientWidth * 0.3) {
      isAdjusting = true;
      const offset = scrollLeft - sectionWidth * 2;
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = sectionWidth + offset; // Sauter à la série du milieu
      
      setTimeout(() => {
        slider.style.scrollBehavior = 'smooth';
        isAdjusting = false;
      }, 50);
    }
  }

  // Écouter le scroll
  slider.addEventListener('scroll', () => {
    updateSlidesOpacity();
    
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      handleInfiniteLoop();
    }, 100);
  });

  // Initialiser l'opacité
  updateSlidesOpacity();

  // Drag horizontal pour desktop
  let isDown = false;
  let startX;
  let scrollLeftStart;

  slider.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeftStart = slider.scrollLeft;
    slider.style.cursor = 'grabbing';
  });

  slider.addEventListener('mouseleave', () => { 
    isDown = false; 
    slider.style.cursor = 'grab'; 
  });

  slider.addEventListener('mouseup', () => { 
    isDown = false; 
    slider.style.cursor = 'grab'; 
  });

  slider.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeftStart - walk;
  });

  // Réinitialiser la position au resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initPosition, 200);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portrait-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.portrait-slider-section .portrait-slider');
  const container = document.querySelector('.portrait-slider-section .portrait-slider-container');
  if (!slider || !container) return;

  // Marquer les images comme "en chargement"
  const images = slider.querySelectorAll('.portrait-img');
  images.forEach(img => {
    if (!img.complete) {
      img.classList.add('loading');
    }
  });

  // Réinitialiser la position du slider
  slider.scrollLeft = 0;

  // Fonction pour gérer l'affichage des dégradés
  function updateGradients() {
    const scrollLeft = slider.scrollLeft;
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const isMobile = window.innerWidth <= 768;
    
    // Seuil adapté pour mobile et PC
    const threshold = isMobile ? 50 : 30;
    
    // Afficher le dégradé gauche si on a scrollé suffisamment
    if (scrollLeft > threshold) {
      container.classList.add('scrolled-left');
    } else {
      container.classList.remove('scrolled-left');
    }
    
    // Masquer le dégradé droit si on est à la fin
    if (scrollLeft >= maxScroll - 5) {
      container.classList.add('scrolled-right');
    } else {
      container.classList.remove('scrolled-right');
    }
  }

  // Écouter le scroll
  slider.addEventListener('scroll', updateGradients);
  
  // Vérifier au chargement
  updateGradients();
  
  // Vérifier après un délai
  setTimeout(updateGradients, 500);
  
  // Vérifier au resize
  window.addEventListener('resize', updateGradients);

  // Drag horizontal pour PC
  let isDown = false;
  let startX;
  let scrollLeftStart;

  slider.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeftStart = slider.scrollLeft;
    slider.style.cursor = 'grabbing';
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeftStart - walk;
  });
});

  } catch(e) { console.error(e); }
})();
})();
